import { pushDataLayerEvent } from "@/features/analytics";
import { accountApi, type TAccount } from "@/shared/services";
import { reactQueryUtils } from "@lib/react-query";
import moment from "moment";

export const validateViewPaymentsTimestamp = (account: TAccount) => {
  const { timestamps = {} } = account;
  const now = moment().toISOString();
  const createdAt = moment(account.createdAt).toISOString();
  if (moment(createdAt).isBefore("2026-03-18")) return;

  if (timestamps.viewPayments) return;

  pushDataLayerEvent("conversion", {
    "event-action": "first payments view",
  });
  timestamps.viewPayments = now;
  accountApi.updateTimestamp("viewPayments");

  reactQueryUtils.setQueryData(["account"], (old: TAccount) => {
    if (!old) return old;
    return {
      ...old,
      timestamps,
    };
  });
};
